import { api } from '@/services/api/main/axios';

type CustomEventPayload = Record<string, unknown>;

export const getCustomConversionsApiRequest = async (
  params: Record<string, unknown> = {},
): Promise<CustomEventPayload> => {
  const res = await api.get<{ payload: CustomEventPayload }>('user/custom-events', { params });
  return res.data.payload;
};

export const postCustomConversionApiRequest = async (
  payload: Record<string, unknown>,
): Promise<unknown> => {
  const res = await api.post<{ payload: unknown }>('user/custom-events', payload);
  return res.data.payload;
};

export const putCustomConversionApiRequest = async (
  payload: { id: string | number } & Record<string, unknown>,
): Promise<unknown> => {
  const res = await api.put<{ payload: unknown }>(`user/custom-events/${payload.id}`, payload);
  return res.data.payload;
};
